import { defineMessages } from 'react-intl';

export default defineMessages({
    notes: {
        id: 'e1p.gateway.views.e1pnotes.account-detail.Notes',
        defaultMessage: 'Notes',
    },
    notesInfoId: {
        id: 'e1p.gateway.directives.e1pnotes.gateway-notes.Note',
        defaultMessage: 'Note',
    },
    notesTopic: {
        id: 'e1p.gateway.directives.e1pnotes.gateway-notes.Topic',
        defaultMessage: 'Topic',
    },
    notesSubject: {
        id: 'e1p.gateway.directives.e1pnotes.gateway-notes.Subject',
        defaultMessage: 'Subject',
    },
    editTopicInput: {
        id: 'e1p.gateway.directives.e1pnotes.activity-summary.Topic',
        defaultMessage: 'Topic',
    },
    editSubjectInput: {
        id: 'e1p.gateway.views.e1pnotes.edit-note-modal.Subject',
        defaultMessage: 'Subject',
    },
    editNotesInput: {
        id: 'e1p.gateway.views.e1pnotes.edit-note-modal.Note',
        defaultMessage: 'Note',
    },
    editNoteTopic: {
        id: 'e1p.gateway.views.e1pnotes.edit-note-modal.note topic',
        defaultMessage: '--note topic--',
    },
    notesSend: {
        id: 'e1p.gateway.views.e1pnotes.edit-note-modal.Send Note',
        defaultMessage: 'Add',
    },
    notesCancel: {
        id: 'e1p.gateway.views.e1pnotes.edit-note-modal.Cancel',
        defaultMessage: 'Cancel',
    },
    searchNotes: {
        id: 'e1p.gateway.directives.e1pnotes.gateway-notes.Search notes',
        defaultMessage: 'Search notes'
    },
    moreNotes: {
        id: 'e1p.gateway.directives.e1pnotes.activity-view-summary.x more note(s)',
        defaultMessage: '{value} more note(s)'
    },
    hideNotes: {
        id: 'e1p.gateway.directives.e1pnotes.activity-view-summary.Hide notes',
        defaultMessage: 'Hide notes'
    }
});
